import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-modules',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class ModulesComponent {
  activeModule: string | null = null;

  modules = [
    {
      id: 'accounting',
      icon: 'payments',
      name: 'Accounting & Finance',
      tagline: 'Full-spectrum financial intelligence',
      description: 'Automated bookkeeping, multi-currency support, real-time P&L, and compliance-ready reporting for total fiscal clarity.',
      color: 'primary',
      link: '/finance',
      features: [
        'Automated Journal Entries & Reconciliation',
        'Multi-Currency & Multi-Company Ledger',
        'Real-Time P&L and Balance Sheet',
        'VAT & Tax Compliance Engine',
        'Budgeting & Cash Flow Forecasting',
        'Integrated Accounts Payable & Receivable'
      ]
    },
    {
      id: 'crm',
      icon: 'people',
      name: 'CRM & Sales',
      tagline: 'Pipeline-to-revenue automation',
      description: 'Manage leads, opportunities, and client relationships from first contact to signed contract with intelligent automation.',
      color: 'secondary',
      link: null,
      features: [
        'Lead & Opportunity Pipeline Management',
        'Automated Follow-Up & Email Sequences',
        'Customer 360° Profile Dashboard',
        'Sales Forecasting & Performance Analytics',
        'Quotation & Contract Generation',
        'Integration with Accounting Module'
      ]
    },
    {
      id: 'hr',
      icon: 'badge',
      name: 'Human Resources',
      tagline: 'People-first workforce orchestration',
      description: 'From onboarding to payroll, manage the full employee lifecycle with structured workflows and data-driven insights.',
      color: 'tertiary',
      link: null,
      features: [
        'Employee Onboarding & Offboarding Flows',
        'Automated Payroll Processing',
        'Attendance & Leave Management',
        'Performance Review & KPI Tracking',
        'Organizational Chart & Role Management',
        'Document Vault & Compliance Tracking'
      ]
    },
    {
      id: 'inventory',
      icon: 'inventory_2',
      name: 'Inventory Management',
      tagline: 'Real-time stock intelligence',
      description: 'Track stock across warehouses, automate reorder points, and maintain perfect supply-demand balance at scale.',
      color: 'primary',
      link: null,
      features: [
        'Multi-Warehouse Stock Tracking',
        'Automated Reorder & Replenishment Alerts',
        'Barcode & Serial Number Scanning',
        'FIFO / LIFO / Average Cost Costing Methods',
        'Purchase Order & Supplier Management',
        'Inventory Valuation Reports'
      ]
    },
    {
      id: 'rental',
      icon: 'car_rental',
      name: 'Vehicle Rental (TransArchitect)',
      tagline: 'Fleet lifecycle automation',
      description: 'End-to-end rental operations from contract creation to vehicle return, with live fleet status and maintenance scheduling.',
      color: 'secondary',
      link: '/rental',
      features: [
        'Real-Time Fleet Availability Calendar',
        'Automated Rental Contract Generation',
        'Customer KYC & Digital Signature',
        'Preventive Maintenance Scheduling',
        'Late Return & Penalty Automation',
        'GPS Integration & Utilization Reports'
      ]
    },
    {
      id: 'projects',
      icon: 'account_tree',
      name: 'Project Management',
      tagline: 'Deliver on time, every time',
      description: 'Plan, execute, and track projects with Gantt charts, milestone tracking, and resource allocation tools built for modern enterprise.',
      color: 'tertiary',
      link: null,
      features: [
        'Interactive Gantt Chart & Timeline',
        'Task Assignment & Progress Tracking',
        'Budget vs. Actual Cost Analysis',
        'Milestone & Deliverable Management',
        'Team Resource Allocation',
        'Client Portal & Status Reporting'
      ]
    }
  ];

  toggleModule(id: string) {
    this.activeModule = this.activeModule === id ? null : id;
  }
}
